import Styles from './scss/upgarde.module.scss'

function UpgradeTranscription({ onOk }: any) {

  const update =()=>{
    if(onOk){
      onOk()
    }
  }

  return (
    <>
      <div className={Styles.maintrant}>
        <div className={Styles.contentupgrade}>
          <div className={Styles.upgradetranscript}>

            <p>Upgrade plan to view Transcription...</p>
            <button onClick={update}>Upgrade</button>
          </div>
        </div>
      </div>
    </>
  );
}
export default UpgradeTranscription;
